import React, {Fragment, PropsWithChildren, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {PagePreloader} from "components/Preloader";
import {requestCurrentUser} from "modules/actions";
import {isSessionChecked} from "modules/selectors";

export const SessionGate: React.FC<PropsWithChildren<unknown>> = ({children}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(requestCurrentUser());
	}, [dispatch]);

	return useSelector(isSessionChecked) ? <Fragment>{children}</Fragment> : <PagePreloader />;
};
